import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=6bc97e5c&"
import script from "./BlackList.vue?vue&type=script&lang=ts&"
export * from "./BlackList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports